
import React from 'react';
import { User, AlertCircle } from 'lucide-react';

const DelaysAndAlerts = ({ alerts }) => {

    console.log("alerts", alerts)
    return (
        <div className="bg-white rounded-2xl p-6 shadow-md h-full">
            <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-bold text-gray-900">Delays & Alerts</h3>
                <div className="flex items-center text-[#D32F2F] font-semibold text-sm">
                    <span className="w-2 h-2 rounded-full bg-[#D32F2F] mr-2"></span>
                    {alerts?.length || 0} Active
                </div>
            </div>

            <div className="flex flex-col gap-4 max-h-[500px] overflow-y-auto pr-2 custom-scrollbar">
                {alerts && alerts.length > 0 ? (
                    alerts.map((alert) => (
                        <div key={alert.id} className={`relative p-4 rounded-xl bg-[#F7F9FB] border-l-4 ${alert.type === 'Critical' || alert.type === 'default' ? 'border-[#FF5C5C]' : 'border-[#D4B95E]'
                            }`}>
                            <h4 className="text-base font-medium text-[#111827] mb-1">{alert.title || alert.name}</h4>
                            <div className="flex items-center text-xs text-[#4B5563] mb-1">
                                <span className="font-semibold mr-1">Task:</span>
                                {alert.liveTask?.name || "N/A"}
                            </div>
                            {alert.liveTask?.workType?.name && (
                                <div className="mb-2">
                                    <span className="text-xs text-amber-700 bg-amber-100 px-2 py-0.5 rounded">
                                        {alert.liveTask.workType.name}
                                    </span>
                                </div>
                            )}
                            <div className="flex items-center text-xs text-[#4B5563]">
                                <User size={14} className="mr-2 text-[#9CA3AF]" />
                                {alert.responsibleUser?.name || alert.person || "Unassigned"}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="flex flex-col items-center justify-center p-12 px-4">
                        {/* Icon */}
                        <div className="w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center">
                            <svg
                                className="w-8 h-8 text-green-500"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                        </div>

                        {/* Main Message */}
                        <h4 className="text-gray-900 font-semibold text-base mb-2">
                            All Clear!
                        </h4>

                        {/* Descriptive Text */}
                        <p className="text-gray-500 text-sm text-center max-w-xs">
                            No delays or alerts to report. Everything is running smoothly today!
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DelaysAndAlerts;
